import ReplaceInput from './ReplaceInput';
import { ReplaceInputProps, ReplaceInputValueProps } from './types';

export type { ReplaceInputProps, ReplaceInputValueProps };
export default ReplaceInput;
